<template>
  <div class="doctor-table" :class="{ 'doctor-table--lookup': purpose === 'modal' || purpose === 'polyclinic-modal' }">

    <modern-filter-bar
      embedded
      :show-timeseries="false"
      :search-text.sync="filter.name"
      search-placeholder="Cari nama dokter"
      @search-keyup="filterByName"
    ></modern-filter-bar>

    <!-- Table -->
    <b-table
      striped
      hover
      responsive
      class="mt-3"
      :items="items"
      :fields="fields">
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: columnWidth(field.key) }" />
      </template>
      <template #cell(email_mobile_phone)="data">
        <span class="d-block">{{ data.item.email }}</span>
        <span class="d-block">{{ data.item.mobile_phone }}</span>
      </template>
      <template #cell(photo)='data'>
        <div class="d-flex justify-content-center align-items-center image-container">
          <div class="doctor-avatar">
            <img
              class="image"
              :src="doctorPhoto(data.item)"
              :alt="data.item.name"
              @error="useDefaultPhoto">
          </div>
        </div>
      </template>
      <!-- <div class="d-flex justify-content-center align-items-center image-container">
        <div style='height: 50px; width: 50px; position: relative'>
          <img
            class="image"
            :src="data.item.photo"
          >
        </div>
      </div> -->
      <template #cell(actions)='data'>
        <template v-if="purpose == 'master'">
          <div class="d-flex flex-nowrap doctor-actions">
            <b-button
              v-for="action in doctorActions().slice(0, visibleActionLimit)"
              :key="action.key"
              size="sm"
              :class="['doctor-action-button', action.buttonClass]"
              v-b-tooltip.hover
              :title="action.label"
              :aria-label="action.label"
              @click="executeDoctorAction(action, data.item)">
              <i :class="action.icon" aria-hidden="true"></i>
            </b-button>

            <b-dropdown
              v-if="doctorActions().length > visibleActionLimit"
              right
              no-caret
              boundary="viewport"
              variant="link"
              class="doctor-action-dropdown"
              toggle-class="doctor-action-button doctor-action-button--more"
              menu-class="doctor-action-overflow-menu">
              <template #button-content>
                <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
                <span class="sr-only">Aksi lainnya</span>
              </template>
              <b-dropdown-item
                v-for="action in doctorActions().slice(visibleActionLimit)"
                :key="action.key"
                @click="executeDoctorAction(action, data.item)">
                <i
                  :class="[action.icon, 'doctor-action-menu-icon']"
                  aria-hidden="true"></i>
                <span>{{ action.label }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template v-if="purpose == 'modal'">
          <b-button
            size="sm"
            class="doctor-choose-btn"
            variant="primary"
            @click="chooseDoctor({ id: data.item.id, name: `${data.item.name} - ${data.item.polyclinic_name}` })"> Pilih </b-button>
        </template>
      </template>
    </b-table>
    <b-pagination
      v-if="items.length != 0"
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      @page-click="pageOnClick"
      class="mt-4"></b-pagination>

  </div>
</template>

<script>

import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js"

export default {

  props: {
    purpose: String,
    polyclinicId: Number,
  },

  data() {
    return {
      // Filter
      filter: {
        name: "",
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      lastCurrentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
          thClass: "doctor-col-number",
          tdClass: "doctor-col-number",
        },
        {
          key: "photo",
          label: "Foto",
          thClass: "doctor-col-photo",
          tdClass: "doctor-col-photo",
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "email_mobile_phone",
          label: "Email & Nomor Handphone",
          sortable: true,
        },
        {
          key: "polyclinic_name",
          label: "Poliklinik",
          sortable: true,
        },
        {
          key: "actions",
          label: "Aksi",
          thClass: "doctor-col-actions",
          tdClass: "doctor-col-actions",
        },
      ],
      // Table Items
      items: [],
      // access management
      manipulateBtn: false,
      scheduleBtn: false,
      holidayBtn: false,
      appointmentBtn: false,
      visibleActionLimit: 5,
    }
  },

  methods: {

    doctorActions() {
      const actions = [
        {
          key: "commission",
          label: "Komisi Dokter",
          icon: "fas fa-user-md",
          buttonClass: "btn-primary",
        },
        {
          key: "detail",
          label: "Detail",
          icon: "fas fa-eye",
          buttonClass: "btn-info",
        },
      ]

      if (this.manipulateBtn) {
        actions.push({
          key: "edit",
          label: "Edit",
          icon: "fas fa-edit",
          buttonClass: "btn-success",
        })
      }

      if (this.appointmentBtn) {
        actions.push({
          key: "appointment",
          label: "Perjanjian",
          icon: "fas fa-tasks",
          buttonClass: "btn-info",
        })
      }

      if (this.holidayBtn) {
        actions.push({
          key: "holiday",
          label: "Libur",
          icon: "fas fa-calendar-times",
          buttonClass: "btn-warning",
        })
      }

      if (this.scheduleBtn) {
        actions.push({
          key: "schedule",
          label: "Jadwal",
          icon: "fas fa-calendar-check",
          buttonClass: "btn-success",
        })
      }

      if (this.manipulateBtn) {
        actions.push({
          key: "delete",
          label: "Hapus",
          icon: "fas fa-trash",
          buttonClass: "btn-danger",
        })
      }

      return actions
    },

    executeDoctorAction(action, doctor) {
      const routes = {
        commission: `/doctor/doctor-commission/${doctor.id}`,
        detail: `/doctor/detail/${doctor.id}`,
        edit: `/doctor/edit/${doctor.id}`,
        appointment: `/doctor/doctor-appointment/${doctor.id}`,
        holiday: `/doctor/holiday/${doctor.id}`,
        schedule: `/doctor/schedule/${doctor.id}`,
      }

      if (routes[action.key]) {
        this.$router.push(routes[action.key])
        return
      }

      if (action.key === "delete") {
        this.btnDeleteOnClick(doctor.id)
      }
    },

    columnWidth(key) {
      if (this.purpose !== "master") return ""

      return {
        number: "48px",
        photo: "82px",
        name: "19%",
        email_mobile_phone: "24%",
        polyclinic_name: "16%",
        actions: "310px",
      }[key] || ""
    },

    doctorPhoto(item) {
      return item && item.photo ? item.photo : "/media/users/doctor-default.svg"
    },

    useDefaultPhoto(event) {
      if (event.target.src.indexOf("doctor-default.svg") === -1) {
        event.target.src = "/media/users/doctor-default.svg"
      }
    },

    async pageOnClick(evt, page) {
      evt.preventDefault()
      this.currentPage = page
      this.lastCurrentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}`
      if (this.purpose == "polyclinic-modal") {
        filterParams += `&polyclinic_id=${this.polyclinicId}`
      }

      let response = await module.paginate(
        "doctors",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      )
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }

      this.items = response.data
    },

    filterByName() {
      debouncer(() => {
        if (this.filter.name == "") {
          this.currentPage = this.lastCurrentPage
        } else {
          this.currentPage = 1
        }
        this.pagination()
      }, 500)
    },

    async btnDeleteOnClick(id) {
      // Delete Data
      let result = await module.delete("doctors/" + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    chooseDoctor(value) {
      this.$emit("chooseDoctor", value)
    },

    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {


        if (access_right[a] == "2002") {
          this.manipulateBtn = true
        }
        if (access_right[a] == "4001") {
          this.scheduleBtn = true
        }
        if (access_right[a] == "4003") {
          this.holidayBtn = true
        }
        if (access_right[a] == "5001") {
          this.appointmentBtn = true
        }
      }
    },
  },

  mounted() {
    if (this.purpose === "modal" || this.purpose === "polyclinic-modal") {
      this.perPage = 10
    }
    // Get Data
    this.pagination()
    // access management
    this.setActiveMenu()
  },

}
</script>

<style scoped>
.doctor-table:not(.doctor-table--lookup) ::v-deep .table {
  min-width: 1050px;
  table-layout: fixed;
}

.doctor-table:not(.doctor-table--lookup) ::v-deep .doctor-col-number,
.doctor-table:not(.doctor-table--lookup) ::v-deep .doctor-col-photo,
.doctor-table:not(.doctor-table--lookup) ::v-deep .doctor-col-actions {
  white-space: nowrap;
}

.doctor-table:not(.doctor-table--lookup) ::v-deep .doctor-col-actions {
  min-width: 310px;
}

.doctor-actions {
  align-items: center;
  gap: 0.25rem;
  min-width: max-content;
  white-space: nowrap;
}

.doctor-action-button.btn,
.doctor-actions ::v-deep .doctor-action-button.btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  min-width: 31px;
  height: 31px;
  padding: 0 !important;
}

.doctor-action-button.btn i,
.doctor-actions ::v-deep .doctor-action-button.btn i {
  margin: 0 !important;
  padding: 0 !important;
}

.doctor-action-dropdown {
  display: inline-flex;
}

.doctor-action-dropdown ::v-deep .doctor-action-button--more {
  color: #52667a !important;
  background: #f7f9fb !important;
  border-color: #d5dee7 !important;
}

.doctor-action-dropdown ::v-deep .doctor-action-overflow-menu {
  min-width: 180px;
  padding: 0.4rem;
  border: 1px solid #e1e7ee;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(var(--skin-deep-rgb), 0.14);
}

.doctor-action-dropdown ::v-deep .dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.6rem 0.75rem;
  border-radius: 7px;
  color: #33475b;
  font-size: 0.82rem;
}

.doctor-action-dropdown ::v-deep .dropdown-item:hover,
.doctor-action-dropdown ::v-deep .dropdown-item:focus {
  color: #234f91;
  background: #f0f5fb;
}

.doctor-action-menu-icon {
  width: 1rem;
  margin: 0 !important;
  text-align: center;
}

.doctor-table:not(.doctor-table--lookup) ::v-deep td:nth-child(4) {
  overflow-wrap: anywhere;
}
</style>
